module.exports = {
    apiKey: "AIzaSyAaQVWqEydHxXtcwaaRyEpiVhJ-vhPJfBo",
    authDomain: "uptime-69073.firebaseapp.com",
    databaseURL: "https://uptime-69073.firebaseio.com",
    projectId: "uptime-69073",
    storageBucket: "",
    messagingSenderId: "43889297910"
}
